import { HttpContextToken, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NotificationContext } from '../models/system-notification';

/** Optional human-readable labels for a specific API action. */
export const SYSTEM_MESSAGE_CONTEXT = new HttpContextToken<NotificationContext>(() => ({}));

export function requestNotificationContext(req: HttpRequest<unknown>, status: number): NotificationContext {
  const url = new URL(req.url, 'http://application.local');
  const path = url.pathname.toLowerCase();
  const services: [string, string][] = [
    [environment.settings, 'Paramètres'], [environment.tsPg, 'Temps de travail'],
    [environment.paie, 'Paie et personnel'], [environment.hseUrl, 'Santé et sécurité'],
  ];
  const direct = services.find(([base]) => {
    const serviceUrl = new URL(base, 'http://application.local');
    const prefix = serviceUrl.pathname.replace(/\/$/, '');
    return url.origin === serviceUrl.origin && (!prefix || path === prefix || path.startsWith(prefix + '/'));
  });
  const source = direct?.[1]
    ?? (/\/(auth|authentication)(\/|$)/.test(path) ? 'Connexion'
    : /\/reporting(\/|$)/.test(path) ? 'Documents et notifications'
    : /\/paie(\/|$)/.test(path) ? 'Paie et personnel'
    : /\/(timesheet|timesheet-s-[^/]+)(\/|$)/.test(path) ? 'Temps de travail'
    : 'Application');
  const operations: Record<string, string> = {
    GET: 'Chargement', POST: 'Envoi', PUT: 'Mise à jour', PATCH: 'Modification', DELETE: 'Suppression',
  };
  return {
    source, operation: operations[req.method] ?? 'Requête', method: req.method,
    // Keep query parameters, credentials and fragments out of notification history.
    endpoint: url.pathname, status, ...req.context.get(SYSTEM_MESSAGE_CONTEXT),
  };
}
